import script from "./aiLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./aiLoading.vue?vue&type=script&setup=true&lang=ts"

import "./aiLoading.vue?vue&type=style&index=0&id=5187b8bf&scoped=true&lang=less"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5187b8bf"]])

export default __exports__